<template>
    <div class="tile-content">
        <p class="stack-m">The start date determines the date that the first subscription period will
            start.
            A subscription may be billed in advance of the start date.</p>
        <div class="grid-content">
            <div class="grid-item grid-item-half grid-item-break-half">
                <v-radio
                    class="stack-m"
                    label="Now"
                    value="now"
                    @update="updateStartTimeType"
                    :model="startTimeType"
                    group="startDateGroup"/>
                <v-radio
                    label="Specific Date"
                    value="specific"
                    @update="updateStartTimeType"
                    :model="startTimeType"
                    group="startDateGroup"/>
                <v-date-input
                    v-if="showDateInput"
                    class="margin-top-s margin-left-default"
                    type="datetime"
                    :value="startTime"
                    @input="updateStartTime"
                    :validate="validate.startTime"
                />
            </div>
        </div>
    </div>
</template>

<script>

    import OrderModel from '@/common/models/order-model';
    import {vDateInput, vRadio} from '@/components/form';


    const startTimeTypesList = Object.values(OrderModel.StartTimeTypes);

    export default {
        name: 'start-date-form',
        components: {
            vDateInput,
            vRadio,
        },
        props: {
            validate: {
                type: Object,
                required: true,
            },
            startTimeType: {
                type: String,
                required: true,
                validator: value => startTimeTypesList.includes(value),
            },
            startTime: {
                type: Object,
                validator: value => value === null || value.isValid(), // moment date
            },
        },
        computed: {
            showDateInput() {
                return this.startTimeType !== OrderModel.StartTimeTypes.now;
            },
        },
        methods: {
            update({startTimeType, startTime} = {}) {
                this.$emit('update', {
                    startTimeType: startTimeType || this.startTimeType,
                    startTime: startTime || this.startTime,
                });
            },
            updateStartTimeType(startTimeType) {
                this.update({startTimeType});
            },
            updateStartTime(startTime) {
                this.update({startTime});
            },
        },
    };
</script>
